import React, { useState } from 'react';
import exclamationIcon from 'Icons/Exclamation-Circle.png';
import Cookies from 'js-cookie';
import { generateUUID, showAlertSnackBar, showSnackBar } from 'utils/Global';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import RMButton from 'components/customComponents/Controls/RMButton';
import { FmlxButton } from 'fmlx-common-ui';
import { useNavigate } from 'react-router-dom';

function RegisterComputer() {
  const navigate = useNavigate();
  const [computerName, setComputerName] = useState('');

  function onComputerNameChanged(e) {
    setComputerName(e.target.value);
  }

  function onRegisterClicked() {
    const compName: string = computerName.trim();

    if (!compName) {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'Computer Name cannot be empty.',
      );
      return;
    }

    const uuid = generateUUID();
    const finalName = computerName + '@' + uuid;

    Cookies.set('regComputerName', finalName, { expires: 3650 }); //10 years
    showSnackBar('Computer Registered Successfully.');
    navigate('/');
  }

  function onCancelClicked() {
    navigate(-1);
  }

  return (
    <div id="register-computer-main-container" className="mainContainer">
      <div id="register-computer-header-row" className="headerRow">
        <div id="register-computer-header-logo" className="headerLogo"></div>
        <div id="register-computer-header-title" className="headerTitle"></div>
      </div>

      <div id="register-computer-inner-container" className="innerContainer">
        <div id="register-computer-login" className="login flex-y-center flex-column">
          <div
            id="register-computer-login-form"
            className="loginForm flex-y-center flex-column"
            style={{ padding: '24px' }}
          >
            <div
              id="register-computer-license-header"
              className="license-header"
              style={{ alignSelf: 'flex-start' }}
            >
              Register Computer <br />
              <br />
            </div>
            <div id="register-computer-wrapper-icon" className="flex">
              <div>
                <img id="register-computer-img-exclamation-icon" src={exclamationIcon} />
              </div>

              <div
                id="register-computer-content"
                className="dialoge-text"
                style={{ marginLeft: '12px' }}
              >
                Please enter your computer’s name to help ROCK MAKER verify it’s the host
                computer.
                <br />
                <br />
                You must also enable cookies in your web browser for the ROCK MAKER web
                app to work correctly
                <br />
                <br />
              </div>
            </div>
            <div
              id="register-computer-content-heading"
              className="dialog-heading"
              style={{ alignSelf: 'flex-start' }}
            >
              Computer Name <br />
              <br />
            </div>
            <div id="register-computer-input-wrapper" style={{ width: '100%' }}>
              <input
                id="register-computer-input-computerName"
                style={{ width: '100%' }}
                onChange={onComputerNameChanged}
                value={computerName}
              ></input>
            </div>
            <div id="register-computer-button-wrapper" className="flex gap-8 mt-4">
              <RMButton
                id="register-computer-register-button"
                onClick={() => onRegisterClicked()}
                label={'REGISTER'}
                variant={FmlxButton.Variant.CONTAIN}
                size={FmlxButton.Size.EXTRA_LARGE}
              />
              <RMButton
                id="register-computer-cancel-button"
                onClick={() => () => onCancelClicked()}
                label={'CANCEL'}
                variant={FmlxButton.Variant.CONTAIN}
                size={FmlxButton.Size.EXTRA_LARGE}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterComputer;
